import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var LOG_LEVELS = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5
};
/**
* Write logs
* @class Logger
*/

export var ConsoleLogger = /*#__PURE__*/function () {
  /**
  * @constructor
  * @param {string} name - Name of the logger
  */
  function ConsoleLogger(name) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'WARN';

    _classCallCheck(this, ConsoleLogger);

    this.name = name;
    this.level = level;
  }

  _createClass(ConsoleLogger, [{
    key: "_padding",
    value: function _padding(n) {
      return n < 10 ? '0' + n : '' + n;
    }
  }, {
    key: "_ts",
    value: function _ts() {
      var dt = new Date();
      return [this._padding(dt.getMinutes()), this._padding(dt.getSeconds())].join(':') + '.' + dt.getMilliseconds();
    }
    /**
    * Write log
    * @method
    * @memeberof Logger
    * @param {string} type - log type, default INFO
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "_log",
    value: function _log(type) {
      var logger_level_name = this.level;

      if (ConsoleLogger.LOG_LEVEL) {
        logger_level_name = ConsoleLogger.LOG_LEVEL;
      }

      if (typeof window !== 'undefined' && window.LOG_LEVEL) {
        logger_level_name = window.LOG_LEVEL;
      }

      var logger_level = LOG_LEVELS[logger_level_name];
      var type_level = LOG_LEVELS[type];

      if (!(type_level >= logger_level)) {
        // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
      }

      var log = console.log.bind(console);

      if (type === 'ERROR' && console.error) {
        log = console.error.bind(console);
      }

      if (type === 'WARN' && console.warn) {
        log = console.warn.bind(console);
      }

      var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);

      for (var _len = arguments.length, msg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msg[_key - 1] = arguments[_key];
      }

      if (msg.length === 1 && typeof msg[0] === 'string') {
        log("".concat(prefix, " - ").concat(msg[0]));
      } else if (msg.length === 1) {
        log(prefix, msg[0]);
      } else if (typeof msg[0] === 'string') {
        var obj = msg.slice(1);

        if (obj.length === 1) {
          obj = obj[0];
        }

        log("".concat(prefix, " - ").concat(msg[0]), obj);
      } else {
        log(prefix, msg);
      }
    }
    /**
    * Write General log. Default to INFO
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "log",
    value: function log() {
      for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      this._log.apply(this, ['INFO'].concat(msg));
    }
    /**
    * Write INFO log
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      this._log.apply(this, ['INFO'].concat(msg));
    }
    /**
    * Write WARN log
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, msg = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      this._log.apply(this, ['WARN'].concat(msg));
    }
    /**
    * Write ERROR log
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, msg = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        msg[_key5] = arguments[_key5];
      }

      this._log.apply(this, ['ERROR'].concat(msg));
    }
    /**
    * Write DEBUG log
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "debug",
    value: function debug() {
      for (var _len6 = arguments.length, msg = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        msg[_key6] = arguments[_key6];
      }

      this._log.apply(this, ['DEBUG'].concat(msg));
    }
    /**
    * Write VERBOSE log
    * @method
    * @memeberof Logger
    * @param {string|object} msg - Logging message or object
    */

  }, {
    key: "verbose",
    value: function verbose() {
      for (var _len7 = arguments.length, msg = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        msg[_key7] = arguments[_key7];
      }

      this._log.apply(this, ['VERBOSE'].concat(msg));
    }
  }]);

  return ConsoleLogger;
}();
ConsoleLogger.LOG_LEVEL = null;